import React from 'react';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import { Button } from 'react-bootstrap';

import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import SimplePrompt from 'components/layout/SimplePrompt';

import { ROLE_CRM_MASTER } from 'js/constants';
import may from 'js/security';

const stageRowSource = {
  beginDrag(props, monitor, component) {
    props.hideDetails();

    return {
      index: props.index,
    };
  },
};

const stageRowTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    props.moveStages(dragIndex, hoverIndex);

    monitor.getItem().index = hoverIndex;
  },
};

@DropTarget('stageRow', stageRowTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
@DragSource('stageRow', stageRowSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
}))
export default class PipelineStageTableRow extends React.Component {
  render() {
    const { isDragging, connectDragSource, connectDragPreview, connectDropTarget, user } = this.props;
    const { messages, shownIndex, index, onClick, name, doDuplicate, handleRemove } = this.props;

    return connectDropTarget(
      connectDragPreview(
        <tr className={(index === shownIndex ? 'shown ' : '') + (index % 2 ? 'even ' : 'odd ')} onClick={onClick}>
          <td className="v-align-middle semi-bold">
            {connectDragSource(<i className="fa fa-drag-handle m-r-10" />)}

            <IntlFormInlineSelector />
            {name}
          </td>
          <td className="v-align-middle"></td>
          <td className="v-align-middle text-right">
            {index === shownIndex ? (
              <Button bsSize="sm" className="btn-rounded m-r-10">
                <i className="fa fa-times" /> {messages.close}
              </Button>
            ) : (
              <Button bsSize="sm" className="btn-rounded m-r-10">
                <i className="fa fa-pencil-alt" /> {messages.edit}
              </Button>
            )}
            <Button bsSize="sm" className="btn-rounded m-r-10" onClick={doDuplicate}>
              <i className="fa fa-files-o" /> {messages.duplicate}
            </Button>
            {may(ROLE_CRM_MASTER, user.roles) && <SimplePrompt onSuccess={handleRemove} />}
          </td>
        </tr>
      )
    );
  }
}
